import { useMelwaysLink } from '@seek/melways-react';
import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { StepId, useStepsCompleted } from 'src/context/use-steps-completed';
import { useJobId } from 'src/context/useJobId';
import { isFeatureEnabled } from 'src/modules/isFeatureEnabled';

interface Props {
  children?: ReactNode;
}

export const Protected = ({ children }: Props) => {
  const { completed } = useStepsCompleted();
  const { jobId } = useJobId();
  const jobRootUrl = useMelwaysLink(`/job/${jobId}/apply`);

  const sectionIsComplete = completed.includes(StepId.DOCUMENTS_ID);
  const startAnyStepFeatureEnabled = isFeatureEnabled('startAnyStep');

  if (!sectionIsComplete && !startAnyStepFeatureEnabled) {
    return <Navigate to={jobRootUrl} replace />;
  }

  return children ? children : <Outlet />;
};
